<template>
  <div id="chart_id"></div>
</template>

<script>
export default {
  name: 'chart-html'
}
</script>

<style scoped>

</style>
